/**
 * `/app/projects` — the entry module.
 *
 * Same shape as the other settings entries: a slot, a self-booting module,
 * idempotent against hot updates and stray imports.
 */
import { mountAppBarHud } from "./index";
import { createProjectsPanel } from "./projects-panel";

let mounted: { destroy(): void } | null = null;

export function bootProjects(root: ParentNode = document) {
  if (mounted) return mounted;

  const slot = root.querySelector<HTMLElement>("[data-projects-slot]");
  if (!slot) return null;

  const panel = createProjectsPanel();
  slot.appendChild(panel.el);

  const bar = mountAppBarHud({
    account: root.querySelector<HTMLElement>("[data-account-slot]"),
  });

  mounted = {
    destroy() {
      panel.destroy();
      bar.destroy();
      mounted = null;
    },
  };
  return mounted;
}

export function unmountProjects() {
  mounted?.destroy();
}

bootProjects();

if (import.meta.hot) import.meta.hot.dispose(() => unmountProjects());
